module.exports = __webpack_public_path__ + "static/media/lc.3995dda7.svg";